/**
 * Environment configuration for TimeTrakrLite
 * 
 * This file centralizes all environment variables and configuration settings
 * that might change between environments (development, staging, production)
 */

// Default values that will be used if environment variables are not set
const defaults = {
  // Analytics configuration
  analytics: {
    // Umami configuration
    umami: {
      enabled: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
      baseUrl: process.env.REACT_APP_UMAMI_URL || '',
      websiteId: process.env.REACT_APP_UMAMI_WEBSITE_ID || '',
      trackInDevelopment: process.env.REACT_APP_TRACK_IN_DEV === 'true' || false,
    },
  },
  
  // Feedback form configuration
  feedback: {
    // Formspree configuration
    formspree: {
      enabled: process.env.REACT_APP_ENABLE_FEEDBACK === 'true',
      endpoint: process.env.REACT_APP_FORMSPREE_ENDPOINT || '',
    },
  },
  
  // Application metadata
  app: {
    version: process.env.REACT_APP_VERSION || '1.7.4',
    name: process.env.REACT_APP_NAME || 'TimeTrakrLite',
    environment: process.env.NODE_ENV || 'development',
  },
};

/**
 * Get environment-specific configuration
 */
export const getEnvironmentConfig = () => {
  // Determine if we should track analytics based on environment and settings
  const trackAnalytics = 
    defaults.analytics.umami.enabled && 
    (process.env.NODE_ENV === 'production' || defaults.analytics.umami.trackInDevelopment);
  
  // Determine if feedback form should be enabled
  const enableFeedback = 
    defaults.feedback.formspree.enabled && 
    defaults.feedback.formspree.endpoint !== '';
  
  return {
    trackAnalytics,
    enableFeedback,
    isDevelopment: process.env.NODE_ENV === 'development',
    isProduction: process.env.NODE_ENV === 'production',
  };
};

/**
 * Export the configuration object
 */
export const envConfig = {
  ...defaults,
  // Add any computed properties here
};

export default envConfig;
